import type { RouteObject } from 'react-router-dom';

/**
 * Workouts area. OWNED BY `m6m7-workouts` (M7); see docs/BUILD-ORCHESTRATION.md.
 *
 * Add screens as children below. router.tsx already includes these routes, so a new
 * screen inside this area never needs a change outside this folder. Pages load lazily.
 *
 *   /plans             members' plans and the gym's templates
 *   /plans/new         start a template (template first, scratch second)
 *   /plans/new?client= start a member's plan
 *   /plans/:planId     the builder
 *   /plans/client/:id  the client profile's Workout panel on its own (until m3 wires the tab)
 */
export const plansRoutes: RouteObject[] = [
  {
    path: 'plans',
    handle: { crumb: 'Workouts' },
    children: [
      { index: true, lazy: async () => ({ Component: (await import('./PlansPage')).PlansPage }) },
      {
        path: 'new',
        handle: { crumb: 'New' },
        lazy: async () => ({ Component: (await import('./BuilderPage')).BuilderPage }),
      },
      {
        path: 'client/:clientId',
        handle: { crumb: 'Member' },
        lazy: async () => ({ Component: (await import('./ClientPanelPage')).ClientPanelPage }),
      },
      {
        path: ':planId',
        handle: { crumb: 'Builder' },
        lazy: async () => ({ Component: (await import('./BuilderPage')).BuilderPage }),
      },
    ],
  },
];
